import "toastify-js/src/toastify.css"
import Toastify from "toastify-js";

function showToast(message, type = "default", textColor = "#000") {
  console.log("showToast called with message:", message);
  
  const getColorVar = (cssVar) =>
    getComputedStyle(document.documentElement).getPropertyValue(cssVar).trim();

  const backgroundColors = {
    default: getColorVar("--color-white"),
    green: getColorVar("--color-green"),
    orange: getColorVar("--color-orange"),
    red: getColorVar("--color-red"),
  };

  const accessibleTextColors = {
    default: "#000000",
    green: "#000000",
    orange: "#000000",
    red: "#000000",
  };

  Toastify({
    text: message,
    duration: 3000,
    close: true,
    gravity: "bottom", // `top` or `bottom`
    position: "right", // `left`, `center` or `right`
    style: {
      background: backgroundColors[type] || backgroundColors.default,
      color: textColor || accessibleTextColors[type] || "#000",
    },
    stopOnFocus: true,
  }).showToast();
}

export function toastify() {
  // Make globally available
  window.showToast = showToast;
}

export default toastify;


